import React, { useEffect } from 'react';
import { useStore } from '../../store';
import { Link, useNavigate } from 'react-router-dom';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../Utils/Functions/Dexie-Setup';

function Home() {
  const { isAuthed, signOut, translation } = useStore();
  const navigate = useNavigate();

  // Database queries
  const numDrafts = useLiveQuery(() => db.dailyFieldReports.where("recordId").below(0).and(dfr => !dfr?.submitted).count(), []);
  const numPending = useLiveQuery(() => db.dailyFieldReports.where("recordId").below(0).and(dfr => dfr?.submitted).count(), []);
  const numSubmissions = useLiveQuery(() => db.dailyFieldReports.where("recordId").above(0).count(), []);

  useEffect(() => {
    if (!isAuthed) {
      navigate("/auth");
    }
  }, [isAuthed, navigate]);

  // --- Style Definitions ---
  // Base styles for all tiles for a more compact view
  const tileBaseStyle = "h-36 flex flex-col items-center justify-center p-2 rounded-lg text-white shadow-md cursor-pointer transition-all duration-200 ease-in-out hover:-translate-y-1 hover:shadow-lg";

  // Specific styles for different tile types
  const primaryTileStyle = `${tileBaseStyle} bg-[#26aae1]`;
  const secondaryTileStyle = `${tileBaseStyle} bg-[#0f314d]`;
  const tertiaryTileStyle = `${tileBaseStyle} bg-gray-600`;
  // --- End Style Definitions ---

  return (
    // Reduced overall padding and grid gap
    <div className='p-2'>
      {/* A consistent 2-column grid for all screen sizes */}
      <div className="grid grid-cols-2 gap-2">

        {/* New Report Tile */}
        <Link to="/form" className="contents">
          <div className={primaryTileStyle}>
            <span className="text-3xl mb-1">➕</span>
            <span className="text-base font-semibold text-center">{translation.newDailyFieldReport}</span>
          </div>
        </Link>

        {/* Drafts Tile */}
        <Link to="/list/drafts" className="contents">
          <div className={secondaryTileStyle}>
            <span className="text-xl font-bold">{numDrafts ?? 0}</span>
            <span className="text-sm font-medium text-center">{translation.drafts}</span>
          </div>
        </Link>

        {/* Pending Submissions Tile */}
        <Link to="/list/pending" className="contents">
          <div className={secondaryTileStyle}>
            <span className="text-xl font-bold">{numPending ?? 0}</span>
            <span className="text-sm font-medium text-center">{translation.pendingSubmissions}</span>
          </div>
        </Link>

        {/* Submissions History Tile */}
        <Link to="/list/history" className="contents">
          <div className={secondaryTileStyle}>
            <span className="text-xl font-bold">{numSubmissions ?? 0}</span>
            <span className="text-sm font-medium text-center">{translation.submissions}</span>
          </div>
        </Link>

        {/* Settings Tile */}
        <Link to="/settings" className="contents">
          <div className={tertiaryTileStyle}>
            <span className="text-2xl mb-1">⚙️</span>
            <span className="text-sm font-medium text-center">{translation.settings}</span>
          </div>
        </Link>

        {/* Logout Tile */}
        <div
          className={tertiaryTileStyle}
          onClick={() => window.confirm(translation.confirmLogout) && signOut()}
        >
          <span className="text-2xl mb-1">🚪</span>
          <span className="text-sm font-medium text-center">{translation.logout}</span>
        </div>
      </div>
    </div>
  );
}

export default Home;
